import { gql } from "@apollo/client";

export const LIST_TRIP_FLIGHT_SUMMARY = gql`
  query ListTripFlightSummary($tripPublicationId: String!) {
    QR_LIST_TRIP_FLIGHT_SUMMARY(tripPublicationId: $tripPublicationId) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        destination
        tripSummary {
          id
          reference
          establishmentId
          pictures {
            link
            isMain
          }
          title
          smallDescription
          detailedDescription
        }
        content {
          childsMaxAge
          babiesMaxAge
          departureInfo {
            departureFlightCity
            departureFlightCountry
          }
          isFlightIncluded
          tripDateSummary {
            id
            startDate
            endDate
            nbDays
            nbNight
            adultPricePerPerson {
              value
              currency
            }
            stepsDate {
              date
              stepIds
                       tripProgramDetails {
            city
            country
            latitude
            longitude
            id
            picture {
              link
              isMain
            }
            stay
            description
            stay
            hosting {
              name
              stars
            }
            activities {
              id
              title
              picture
              description
              isIncluded
              adultPricePerPerson {
                value
                currency
              }
              childPricePerPerson {
                value
                currency
              }
              babiesPricePerPerson {
                value
                currency
              }
            }
            ranking {
              rank
              title
            }
            options {
              id
              picture
              title
              description
              adultPricePerPerson {
                value
                currency
              }
              childPricePerPerson {
                value
                currency
              }
              babiesPricePerPerson {
                value
                currency
              }
            }
          }
            }
          }
        }
      }
    }
  }
`;

export const QR_GET_TRIP_PUBLICATION_SUMMARY = gql`
  query getTripPublication($tripPublicationId: String!) {
    QR_GET_TRIP_PUBLICATION_SUMMARY(tripPublicationId: $tripPublicationId) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        id
        tripId
        tripDateId
        picture
        reference
        country
        city
        locations
        title
        smallDescription
        nbNights
        startDate
        endDate
        price {
          value
          currency
        }
        globalMark
        nbOfopinion
        isFavorite
        favoriteId
        activities
        options
      }
    }
  }
`;
